// extracted by mini-css-extract-plugin
export var navbarSubLink = "B_f7 d_f7 d_f1 d_Y d_b9 d_dk d_bq d_bR";
export var menuLink = "B_tv d_fY d_dy";
export var subPageLink = "B_gb d_gb";
export var burger = "B_ty";
export var sublinkSize = "B_tz";
export var linkSize = "B_tB";
export var Link = "B_r2 r_r2 r_rf r_rz";